import {IFormField} from "../../../models/forms/form-field.interface";
import {NullableString, NullableUndefinedString} from "../../../types/nullable-types";
import parsePhoneNumberLibJs, {PhoneNumber} from 'libphonenumber-js';
import {CountryData} from "react-phone-input-2";


export function setPhoneFieldsValues(phoneField: IFormField<NullableString>, countryField: IFormField<NullableString> | undefined, value: string, countryData: CountryData) {
    if(value) {
        if(!value.startsWith('+')) {
            value = '+' + value;
        }
    }
    phoneField.setValue(value);
    countryField?.setValue(countryData?.countryCode?.toUpperCase() ?? null);
}

export function phoneNumberParse(phoneNumberValue: NullableUndefinedString): PhoneNumber | undefined{
    if(!phoneNumberValue) {
        return undefined;
    }

    if(!phoneNumberValue.startsWith('+')) {
        phoneNumberValue = '+' + phoneNumberValue;
    }

    return parsePhoneNumberLibJs(phoneNumberValue);
}

export function getPhoneNumberCountry(phoneNumberValue: NullableUndefinedString): NullableString {
    if(!phoneNumberValue) {
        return null;
    }

    const phoneNumber = phoneNumberParse(phoneNumberValue);
    if(!phoneNumber) {
        return null;
    }

    if (phoneNumber.isValid() && phoneNumber.country) {
        return phoneNumber.country;
    }

    return null;
}

export function setInitialPhoneCountry(phoneField: IFormField<NullableString>, countryField: IFormField<NullableString> | undefined): void {
    if(!phoneField.value) {
        return;
    }

    if(!countryField) {
        return;
    }

    if(countryField.value) {
        return;
    }


    const country = getPhoneNumberCountry(phoneField.value.toString());
    if(country) {
        countryField.setValue(country);
    }
}

export function formatPhoneNumber(phoneNumber: NullableString): NullableString {
    try {
        if(!phoneNumber) {
            return phoneNumber;
        }

        const parsedPhoneNumber = phoneNumberParse(phoneNumber);
        if(!parsedPhoneNumber) {
            return phoneNumber;
        }

        return parsedPhoneNumber.formatInternational();
    } catch (err) {
        console.error(`Failed to format phone number ${phoneNumber}`, err);
        return phoneNumber;
    }

}
